module.exports = __webpack_public_path__ + "img/TECNOLOGIA-CIAZ-3.afbdf976.jpg";